"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonParseError = void 0;
const http_error_1 = require("./http-error");
class JsonParseError extends http_error_1.HttpError {
    constructor() {
        super("Bad Request", 400, "errors/json-parse");
    }
}
exports.JsonParseError = JsonParseError;
